import { render, staticRenderFns } from "./TypeControlDetailInTable.vue?vue&type=template&id=4ef9c38a"
import script from "./TypeControlDetailInTable.vue?vue&type=script&lang=js"
export * from "./TypeControlDetailInTable.vue?vue&type=script&lang=js"
import style0 from "./TypeControlDetailInTable.vue?vue&type=style&index=0&id=4ef9c38a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports